import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Typography, colors, ScalableContainer } from '@ui-components/neo.tax';

const LaptopAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledImageContainer = styled.div({
  animation: `${LaptopAnimation} 1s ease-in-out`,
  position: 'relative',
  width: '100%',
});

export const StyledLaptopImage = styled.img({
  maxWidth: 'none',
  position: 'relative',
  width: '153%',
  zIndex: 2,
});

const TextEnterAnimation = keyframes`
  from, 40% {
    opacity: 0;
    transform: scale(0);
  }
  90% {
    transform: scale(1.03);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledName = styled(Typography)({
  animation: `${TextEnterAnimation} 1s ease-in-out`,
  color: colors.gray[100],
  display: 'inline-block',
});

export const StyledQuote = styled(Typography)({
  color: colors.white,
  fontStyle: 'italic',
  marginBottom: '1rem',
});

const QuoteContainerAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  70% {
    transform: scale(1.04);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledQuoteContainer = styled.div({
  animation: `${QuoteContainerAnimation} 1s ease-in-out`,
  width: '100%',
  paddingRight: '4.5%',
});

export const StyledScalableContainer = styled(ScalableContainer)({
  marginBottom: '1rem',
});

export const StyledScreenshotImage = styled.img({
  aspectRatio: '59/36',
  left: '23%',
  position: 'absolute',
  top: '5%',
  zIndex: 1,
});

export const StyledTestimonialContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  marginBottom: 'auto',
  marginLeft: 'auto',
  marginTop: 'auto',
  paddingLeft: '6vmin',
  paddingTop: '6vh',
  width: '79vmin',
});

export const StyledTestimonialRootContainer = styled.div({
  backgroundColor: colors.gray[700],
  display: 'flex',
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
});

export const StyledTextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  placeItems: 'flex-start',
});

export const StyledTitleAndCompany = styled(Typography)({
  animation: `${TextEnterAnimation} 1.5s ease-in-out`,
  color: colors.gray[200],
  display: 'inline-block',
});

export const StyledCompanyImage = styled.img({
  animation: `${QuoteContainerAnimation} 1s ease-in-out`,
  height: 'auto',
  maxHeight: '40px',
  maxWidth: '200px',
  objectFit: 'contain',
  width: 'fit-content',
  marginBottom: '1rem',
});

export const StyledAuthorContainer = styled.div({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
});

export const StyledProfileImage = styled.img({
  animation: `${TextEnterAnimation} 1s ease-in-out`,
  borderRadius: '50%',
  height: '50px',
  objectFit: 'cover',
  width: '50px',
});

export const StyledAuthorInfo = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});
